import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

// Import your SVGs
import AddressIcon from "../Assets/img/address.svg";
import EmailIcon from "../Assets/img/email.svg";
import CallIcon from "../Assets/img/call.svg";
import TimeIcon from "../Assets/img/time (1).svg";
import LinkedinIcon from "../Assets/img/linkdin.svg";
import InstagramIcon from "../Assets/img/instagram.svg";
import FacebookIcon from "../Assets/img/facebook.svg";
import WhatsappIcon from "../Assets/img/whatsapp.svg";

const TopHeader = () => {
  return (
    <div className="fixed-top">
      <div className="top_headers py-2">
        <Container>
          <Row className="align-items-center">
            {/* Left side - Address, Email, Phone, Time */}
            <Col md={9}>
              <div className="d-flex flex-wrap gap-3 main_media">
                {/* Address (Google Maps link) */}
                <div className="d-flex align-items-center address_bar">
                  <img src={AddressIcon} alt="Address" className="me-2" />
                  <Link
                    to="https://www.google.com/maps/place/Anaxis+House,+Makarba+Road,+Ahmedabad,+380058"
                    target="_blank"
                    className="mb-0 small text-decoration-none text-white"
                  >
                    Anaxis House, Makarba Road, Ahmedabad, 380058
                  </Link>
                </div>

                {/* Email */}
                <div className="d-flex align-items-center address_bar">
                  <img src={EmailIcon} alt="Email" className="me-2" />
                  <Link
                    to="mailto:info@anaxistech.com"
                    className="mb-0 small text-decoration-none text-white"
                  >
                    info@anaxistech.com
                  </Link>
                </div>

                {/* Phone */}
                <div className="d-flex align-items-center address_bar">
                  <img src={CallIcon} alt="Phone" className="me-2" />
                  <Link
                    to="tel:+919023148808"
                    className="mb-0 small text-decoration-none text-white"
                  >
                    +91 9023148808
                  </Link>
                </div>

                {/* Time (static info) */}
                <div className="d-flex align-items-center address_bar">
                  <img src={TimeIcon} alt="Working Hours" className="me-2" />
                  <p className="mb-0 small">Working hours (10am-7pm)</p>
                </div>
              </div>
            </Col>

            {/* Right side - Social Icons */}
            <Col md={3} className="text-md-end mt-2 mt-md-0">
              <ul className="list-unstyled d-flex justify-content-md-end justify-content-start gap-3 mb-0 social_icons">
                <li>
                  <Link
                    to="https://www.linkedin.com/company/anaxisrecruit/"
                    target="_blank"
                  >
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.instagram.com/anaxisrecruit/"
                    target="_blank"
                  >
                    <img src={InstagramIcon} alt="Instagram" />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.facebook.com/AnaxisRecruit"
                    target="_blank"
                  >
                    <img src={FacebookIcon} alt="Facebook" />
                  </Link>
                </li>
                <li>
                  <Link to="https://wa.me/919023148808" target="_blank">
                    <img src={WhatsappIcon} alt="Whatsapp" />
                  </Link>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default TopHeader;
